import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getData,postData } from "../../../Service/ApiMethod";
import {
  RECOMMENDED_CANDIDATES,
  RECRUITER_PLAYLIST,NEARME
} from '../../../Service/service'
// import AddToList from '../../Vaccancy/AddToList'
import BlackScreen from "../BlackScreen";
import { useTranslation } from "react-i18next"; 
import AddToListRecomended from "../../Vaccancy/toggles/AddToListRecomended";
import { async } from "react-input-emoji";
import { lang } from "../../../lang";
// import profileData from './ProfileData' 

const RecommendedProfile = (props) => {
  const [ln,setLn] = useState('en')
  const [popup, setPopup] = useState(false);
  const [recommendedCandidates, setRecommendedCandidates] = useState(props.data);
  const [isError, setIsError] = useState();
  const [playlist, setPlaylist] = useState();
  const [clickedId, setClickedId] = useState();
  const [iindex, setIindex] = useState();
  const [blackPopup, setBlackPopup] = useState(true);
  const [seekerShare, setSeekershare] = useState(false)
  const [seekerData, setSeekerdata] = useState([])
  const location = useLocation()
  console.log('location', location)

  console.log(props.data,'clickeddid', clickedId)

  // useEffect(()=>{
  //   checkShare()
  // },[])

  useEffect(()=>{
    if(localStorage.getItem("language") != null){
        setLn(localStorage.getItem("language"))
      } 
  },[])





  const getRecommendedCandidates = () => {
    getData(RECOMMENDED_CANDIDATES) 
      .then((response) => response.json())
      .then((data) => {
        console.log(recommendedCandidates,props.data,"recruiter/RecommendedCandidate/00000",data );
          setRecommendedCandidates(data.data);
      })
      .catch((err) => {
        console.log("Error in categories from Post Form", err);
        console.log(" code Error", err);
        setIsError(err.message);
        console.log(isError);
        setTimeout(()=>{
          setSeekershare(true)
        },10000)
      });
  };










  // const getRecommendedCandidates = () => {
  //   var request = {
  //     radius: props.distance,
  //   };
  //   postData(request,NEARME)
  //   // getData(RECOMMENDED_CANDIDATES)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       console.log(data,"oookfffffffffffffffffff");
  //       // if (location?.pathname == '/home') {
  //         setRecommendedCandidates(data.data);
  //       // } else {
  //       //   setRecommendedCandidates(data.data);
  //       // }
  //     })
  //     .catch((err) => {
  //       console.log("Error in categories from Post Form", err);
  //       console.log(" code Error", err);
  //       setIsError(err.message);
  //       console.log(isError);
  //     });
  // };
  console.log('recommendedCandidates', recommendedCandidates)
  const getPlaylist = () => {
    getData(RECRUITER_PLAYLIST)
      .then((response) => response.json())
      .then((data) => {
        setPlaylist(data.data);
      })
      .catch((err) => {
        console.log("Error in categories from Post Form", err);
        console.log(" code Error", err);
        setIsError(err.message);
        console.log(isError);
      });
  };
  console.log('recommended Candidates component', recommendedCandidates);

  console.log('recommended Candidates component', recommendedCandidates,
    'playlist', playlist);

  useEffect(() => {

    getRecommendedCandidates();
    getPlaylist();
  }, [blackPopup]);

useEffect(()=>{
  getRecommendedCandidates();
    getPlaylist();
},[]) 


  const { t } = useTranslation()

  return ( 
    <>
      {recommendedCandidates != null ?
        (recommendedCandidates != undefined ? (
          recommendedCandidates.length !== 0 ? (
            recommendedCandidates?.map((item, index) => {
              console.log("asssssss",item);
              return (
                <div
                  className="col-lg-3 col-md-4 col-sm-6 col-12 "
                  id={item.id}
                  key={index}
                  onClick={(e) => {
                    e.stopPropagation()
                    setIindex(index)
                    setBlackPopup(true)
                    console.log('1 div')
                  }}
                >
                  <div className="recommended-profile profile-img-outer-home">
                    <div className="row profile-img-outer">
                      <div className=" px-0 relative flex-center">
                      <div className='outer-box'>
                        {item?.is_premium &&
                          <div className="premium-tag-outer" style={{}}>
                            <img
                              src="./images/premium-tag.png"
                              className="premium-tag"
                              // title="Call"
                              alt=""
                            />
                          </div>
                        }
                       
                          <img src={item?.image == null ? "https://www.tnprivatejobs.tn.gov.in/asset/images/profile-image-1_1.png":item?.image} alt="" className="profile-img " />
                      
                        {/* <img
                        src="./images/save-profile.png"
                        alt=""
                        className="save-profile"
                        style={{ cursor: "pointer" }}
                      /> */}
                        {props?.bottom}
                        </div>
                      </div>
                      <div className="pl-0 pr-0">
                        <h2 className="card-heding relative">
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              e.stopPropagation()
                              props?.openDetailPopup()
                              console.log('2 div')
                            }}
                          >
                            {item?.first_name + " " + item?.last_name}
                          </span>
                          <img
                            src="./images/send-job.png"
                            alt=""
                            className="addprofile"
                            onClick={(e) => {

                              e.stopPropagation()
                              setPopup(true);
                              setClickedId(item?.id);
                              console.log('3 div',item)
                            }}
                            style={{ }}
                          />
                          {/* {item?.is_verified ? (
                          <>
                            <img src="./images/verified.png" alt="" />
                            <span className="verified">Verified</span>
                          </>
                        ) : null} */}
                        </h2>
                        <p className="designation">{item?.profile_title}</p>
                        {(parseInt(item?.availability)) > 0 &&
                          <p className="profile-availbility">
                            ({t('Available')} {item?.availability})
                          </p>
                        }

                        <div className="row mt-2">
                          <div className="col-6 px-0">
                            <p className="card-subHeading">{lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommendedComp['Total Experience']:""}</p>
                            <p className="card-subHeading">{lang && Object.keys(lang).length > 0 ? lang[ln]?.UnlockedProfileComp['Current Location']:""}</p>
                            <p className="card-subHeading">{lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommendedComp['Package']:""}</p>
                            <p className="horizontal-center">
                              <img
                                src="./images/match-badge.png"
                                className="img-size18"
                                alt="hi"
                              />
                              <span className="ms-1 match-profile">
                                {parseInt(item?.percentage_match)}% {lang && Object.keys(lang).length > 0 ? lang[ln]?.BlackCard['Match']:""}
                              </span>
                            </p>
                          </div>
                          <div className="col-6 px-0">
                            {/* {item?.experience?.map((emp, i) => {
                              return ( */}
                                <p className="profile-info">
                                  {item?.expected_salary} {(parseInt(item?.expected_salary) > 1) ? lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommendedComp['Years']:"" : lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommendedComp['Year']:""}
                                </p>
                              {/* )
                            })} */}


                            <p className="profile-info">{item?.distance} { lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommendedComp['KM Away']:""} </p>
                            <p className="profile-info">
                              {item?.currency} {item?.expected_salary} {lang && Object.keys(lang).length > 0 ? lang[ln]?.new[item?.compensation_details]:""}
                            </p>
                            {/* <p className="profile-last-seen" >
                              <span className="last-seen">{t('Last Seen')}</span>
                              <span style={{ color: 'blue' }}>{item?.updated_at} {t('ago')}</span>
                            </p> */}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/** (item?.user_id == setBlackScreenID) &&*/}
                  </div>


                  {((iindex == index) && blackPopup) &&
                    <div className='blur-screen-full-area flex-center ' style={{ position: 'fixed', top: '0', zIndex: '99999999999999', height: '100vh', overflow: 'auto', background: 'rgb(0, 0, 0, 0.7' }}>
                      <BlackScreen item={item} setBlackPopupValue={setBlackPopup} style={{ position: 'fixed' }} />
                    </div>
                  }
                 
                </div>
              );
            })
          ) : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '20px', color: 'grey', marginTop: "100px", marginBottom: '100px' }}>{t('No Data Found')}</div>
        ) : <> {t('No Data Found')}  </>
        ) : <> {t('No Data Found')}</>}

      {popup ? (
        <AddToListRecomended
          playlist={playlist}
          closePopup={setPopup}
          seekerID={clickedId}
        />
      ) : null}
    </>
  );
};

export default RecommendedProfile;
